module.exports = __webpack_public_path__ + "img/40_38_024_320.9a503e1f.jpg";